/*个人申报明细报表 */
import { $http, buildHeaders } from "./index";

//获取列表
export const taxdeclarereportemployee_list = (params) => {
  return $http.get("/admin/TaxDeclareReportEmployee/index", { params });
};

//导出
export const taxdeclarereportemployee_export = (params) => {
  return $http.get("/admin/TaxDeclareReportEmployee/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};
